// extracted by mini-css-extract-plugin
module.exports = {"defaultIconButton":"style_defaultIconButton__y-kMRsAuwGMI4qUwrN0Vq","copyValue":"style_copyValue__3PmtnSmxIHTerXEjb0gsNl"};